(function () {
  'use strict';

  function moneyFromCents(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || (window.theme && theme.moneyFormat) || '${{amount}}');
    }
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function initGallery(root) {
    var track = root.querySelector('[data-oxiram-gallery-track]');
    var mainWrap = root.querySelector('[data-oxiram-gallery-main]');
    var thumbsWrap = root.querySelector('[data-oxiram-gallery-thumbs]');
    var countLabel = root.querySelector('[data-oxiram-gallery-count]');
    var prevBtn = root.querySelector('[data-oxiram-gallery-prev]');
    var nextBtn = root.querySelector('[data-oxiram-gallery-next]');
    if (!track || !mainWrap) return;

    var slides = track.querySelectorAll('.gallery-slide');
    var total = slides.length;
    if (!total) return;
    var current = 0;
    var thumbs = [];

    if (thumbsWrap) {
      thumbsWrap.innerHTML = '';
      slides.forEach(function (s, i) {
        var media = s.querySelector('img, video');
        var src = media
          ? media.getAttribute('src') || (media.querySelector && media.querySelector('img') && media.querySelector('img').src) || ''
          : '';
        if (media && media.tagName === 'VIDEO') {
          src = media.getAttribute('poster') || src;
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gallery-thumb' + (i === 0 ? ' active' : '');
        btn.setAttribute('aria-label', 'View image ' + (i + 1));
        btn.innerHTML = src ? '<img src="' + src + '" alt="">' : '';
        btn.addEventListener('click', function () {
          goTo(i);
        });
        thumbsWrap.appendChild(btn);
        thumbs.push(btn);
      });
    }

    function goTo(i) {
      current = ((i % total) + total) % total;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('active', idx === current);
      });
      if (countLabel) countLabel.textContent = current + 1 + ' / ' + total;
    }

    root._oxGalleryGoTo = goTo;
    root._oxGalleryGoToMedia = function (mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i += 1) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
          goTo(i);
          return;
        }
      }
    };

    if (nextBtn) nextBtn.addEventListener('click', function () {
      goTo(current + 1);
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      goTo(current - 1);
    });

    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    function start(x) {
      dragging = true;
      startX = x;
      deltaX = 0;
      track.style.transition = 'none';
    }
    function move(x) {
      if (!dragging) return;
      deltaX = x - startX;
      track.style.transform = 'translateX(calc(-' + current * 100 + '% + ' + deltaX + 'px))';
    }
    function end() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = 'transform .45s cubic-bezier(.22,.61,.36,1)';
      if (Math.abs(deltaX) > 60) {
        deltaX < 0 ? goTo(current + 1) : goTo(current - 1);
      } else {
        goTo(current);
      }
      deltaX = 0;
    }

    mainWrap.addEventListener('touchstart', function (e) {
      start(e.touches[0].clientX);
    }, { passive: true });
    mainWrap.addEventListener('touchmove', function (e) {
      move(e.touches[0].clientX);
    }, { passive: true });
    mainWrap.addEventListener('touchend', end);
    mainWrap.addEventListener('mousedown', function (e) {
      e.preventDefault();
      start(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      if (dragging) move(e.clientX);
    });
    window.addEventListener('mouseup', end);

    mainWrap.setAttribute('tabindex', '0');
    mainWrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') goTo(current + 1);
      if (e.key === 'ArrowLeft') goTo(current - 1);
    });
  }

  function closeAllDropdowns(root, except) {
    root.querySelectorAll('[data-oxiram-dd-menu]').forEach(function (menu) {
      if (except && menu === except) return;
      menu.hidden = true;
      var trigger = menu.closest('.ox-dd');
      if (trigger) {
        var btn = trigger.querySelector('[data-oxiram-dd-trigger]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initBuyBox(root) {
    var form = root.querySelector('[data-oxiram-product-form]');
    if (!form) return;

    var qtyEl = form.querySelector('[data-oxiram-qty]');
    var qtyInput = form.querySelector('[data-oxiram-qty-input]');
    var minus = form.querySelector('[data-oxiram-qty-minus]');
    var plus = form.querySelector('[data-oxiram-qty-plus]');
    var addBtn = form.querySelector('[data-oxiram-add]');
    var buyNowBtn = form.querySelector('[data-oxiram-buy-now]');
    var variantInput = form.querySelector('[data-oxiram-variant-id]');
    var priceNow = root.querySelector('[data-oxiram-price-now]');
    var priceWas = root.querySelector('[data-oxiram-price-was]');
    var savePill = root.querySelector('[data-oxiram-price-save]');
    var availability = root.querySelector('[data-oxiram-availability]');
    var skuEl = root.querySelector('[data-oxiram-sku]');
    var skuWrap = root.querySelector('[data-oxiram-sku-wrap]');
    var specSku = root.querySelector('[data-oxiram-spec-sku]');
    var specWeight = root.querySelector('[data-oxiram-spec-weight]');
    var stickyVariant = root.querySelector('[data-oxiram-sticky-variant]');
    var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';

    var inStockLabel = availability ? (availability.getAttribute('data-in-stock-label') || 'In stock — ready to ship') : '';
    var soldOutLabel = availability ? (availability.getAttribute('data-sold-out-label') || 'Sold out') : '';

    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, Math.min(99, n));
      if (qtyEl) qtyEl.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
    }
    if (plus) plus.addEventListener('click', function () {
      setQty(qty + 1);
    });
    if (minus) minus.addEventListener('click', function () {
      setQty(qty - 1);
    });

    var jsonEl = root.querySelector('[data-oxiram-product-json]');
    var productData = null;
    try {
      productData = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch (e) {
      productData = null;
    }

    var optionRows = form.querySelectorAll('[data-oxiram-option]');

    function getSelectedOptions() {
      var selected = [];
      optionRows.forEach(function (row) {
        var active = row.querySelector('.ox-dd__option.is-selected, .ox-swatch.is-selected');
        selected.push(active ? active.getAttribute('data-oxiram-option-value') : '');
      });
      return selected;
    }

    function findVariant(selected) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return String(opt) === String(selected[i]);
        });
      }) || null;
    }

    function findVariantForOptionValue(optionIndex, value, selected) {
      if (!productData || !productData.variants) return null;
      var probe = selected.slice();
      probe[optionIndex] = value;
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return String(opt) === String(probe[i]);
        });
      }) || null;
    }

    function formatWeight(variant) {
      if (!variant || !variant.weight || variant.weight <= 0) return '—';
      var w = Number(variant.weight);
      var unit = variant.weight_unit || 'g';
      return w + ' ' + unit;
    }

    function refreshDropdownPrices(selected) {
      optionRows.forEach(function (row, rowIndex) {
        var options = row.querySelectorAll('[data-oxiram-option-value]');
        options.forEach(function (btn) {
          var value = btn.getAttribute('data-oxiram-option-value');
          var match = findVariantForOptionValue(rowIndex, value, selected);
          var priceEl = btn.querySelector('[data-oxiram-option-price]');
          if (match && priceEl) {
            priceEl.textContent = moneyFromCents(match.price, moneyFormat);
          }
          var ok = !!(match && match.available);
          btn.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function updateDropdownTriggers(selected, variant) {
      optionRows.forEach(function (row, rowIndex) {
        var valueEl = row.querySelector('[data-oxiram-dd-value]');
        var priceEl = row.querySelector('[data-oxiram-dd-price]');
        var labelEl = row.querySelector('[data-oxiram-option-label]');
        var trigger = row.querySelector('[data-oxiram-dd-trigger]');
        var optionName = row.getAttribute('data-option-name') || '';
        var val = selected[rowIndex] || '';
        if (valueEl) valueEl.textContent = val;
        if (labelEl) labelEl.textContent = val;
        if (trigger) trigger.setAttribute('aria-label', optionName + ': ' + val);
        if (priceEl && variant) {
          var match = findVariantForOptionValue(rowIndex, val, selected);
          if (match) priceEl.textContent = moneyFromCents(match.price, moneyFormat);
        }
      });
    }

    function updateVariantUI(variant) {
      if (!variant) return;

      if (priceNow) priceNow.textContent = moneyFromCents(variant.price, moneyFormat);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = moneyFromCents(variant.compare_at_price, moneyFormat);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (savePill) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          savePill.textContent = 'Save ' + moneyFromCents(variant.compare_at_price - variant.price, moneyFormat);
          savePill.hidden = false;
        } else {
          savePill.hidden = true;
        }
      }

      if (availability) {
        var availText = availability.querySelector('[data-oxiram-avail-text]');
        if (availText) {
          availText.textContent = variant.available ? inStockLabel : soldOutLabel;
        } else {
          availability.textContent = variant.available ? inStockLabel : soldOutLabel;
        }
        availability.classList.toggle('is-sold-out', !variant.available);
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        var defaultLabel = addBtn.getAttribute('data-default-label') || '+ Add';
        addBtn.textContent = variant.available ? defaultLabel : 'Sold Out';
      }
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      if (variantInput) variantInput.value = variant.id;

      var sku = variant.sku || '';
      var skuInternal = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(sku);
      if (skuEl) skuEl.textContent = skuInternal ? '' : sku;
      if (skuWrap) skuWrap.hidden = !sku || skuInternal;
      if (specSku) specSku.textContent = skuInternal || !sku ? '—' : sku;
      if (specWeight) specWeight.textContent = formatWeight(variant);
      if (stickyVariant) stickyVariant.textContent = variant.title || variant.name || '';

      root.querySelectorAll('[data-oxiram-sticky-price]').forEach(function (el) {
        el.textContent = moneyFromCents(variant.price, moneyFormat);
      });

      if (variant.featured_media && root._oxGalleryGoToMedia) {
        root._oxGalleryGoToMedia(variant.featured_media.id);
      }

      try {
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState({}, '', url.toString());
        }
      } catch (err) {}
    }

    function selectOption(row, btn) {
      var rowIndex = Number(row.getAttribute('data-option-index'));
      var options = row.querySelectorAll('[data-oxiram-option-value]');
      options.forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-selected', 'true');

      var selected = getSelectedOptions();
      refreshDropdownPrices(selected);
      var variant = findVariant(selected);
      if (variant) {
        updateDropdownTriggers(selected, variant);
        updateVariantUI(variant);
      }
    }

    if (optionRows.length && productData) {
      optionRows.forEach(function (row) {
        var trigger = row.querySelector('[data-oxiram-dd-trigger]');
        var menu = row.querySelector('[data-oxiram-dd-menu]');
        var optionBtns = row.querySelectorAll('[data-oxiram-option-value]');

        if (trigger && menu) {
          trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            var isOpen = !menu.hidden;
            closeAllDropdowns(root);
            if (!isOpen) {
              menu.hidden = false;
              trigger.setAttribute('aria-expanded', 'true');
            }
          });
        }

        optionBtns.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (btn.classList.contains('is-unavailable') && !btn.classList.contains('is-selected')) return;
            selectOption(row, btn);
            closeAllDropdowns(root);
          });
        });
      });

      var initial = getSelectedOptions();
      refreshDropdownPrices(initial);
      updateDropdownTriggers(initial, findVariant(initial));
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAllDropdowns(root);
      else if (!e.target.closest('.ox-dd')) closeAllDropdowns(root);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns(root);
    });

    function addToCart(redirectCheckout) {
      var id = variantInput ? Number(variantInput.value) : 0;
      if (!id) return Promise.reject();

      return fetch(
        window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        }
      ).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      }).then(function () {
        if (redirectCheckout) {
          var checkoutUrl = (window.Shopify && Shopify.routes && Shopify.routes.root)
            ? Shopify.routes.root + 'checkout'
            : '/checkout';
          window.location.href = checkoutUrl;
          return;
        }
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.oxiram-header .badge, .icon-btn .badge').forEach(function (b) {
              b.textContent = String(cart.item_count);
              b.hidden = cart.item_count < 1;
            });
          })
          .catch(function () {});
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        var label = addBtn.getAttribute('data-default-label') || addBtn.textContent.trim();
        addBtn.classList.add('is-loading');
        addBtn.textContent = 'Adding…';

        addToCart(false)
          .then(function () {
            addBtn.textContent = 'Added ✓';
            addBtn.classList.remove('is-loading');
            setTimeout(function () {
              addBtn.textContent = '+ ' + label.replace(/^\+ /, '');
            }, 1600);
          })
          .catch(function () {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = 'Try again';
            setTimeout(function () {
              addBtn.textContent = '+ ' + label.replace(/^\+ /, '');
            }, 1600);
          });
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (buyNowBtn.disabled) return;
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Processing…';
        addToCart(true).catch(function () {
          var v = findVariant(getSelectedOptions());
          buyNowBtn.disabled = !(v && v.available);
          buyNowBtn.textContent = buyNowBtn.getAttribute('data-default-label') || 'Buy Now';
        });
      });
    }

    root._oxAddToCart = function () {
      if (addBtn && !addBtn.disabled) addBtn.click();
    };
  }

  function initStickyCart(root) {
    var bar = root.querySelector('[data-oxiram-sticky-cart]');
    var buyBox =
      root.querySelector('#oxiram-pdp-cta') ||
      root.querySelector('[data-oxiram-buy-box]');
    var stickyBtn = root.querySelector('[data-oxiram-sticky-submit]');
    if (!bar || !buyBox) return;

    function headerOffset() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--oxiram-header-offset');
      var n = parseFloat(raw);
      return isFinite(n) && n > 0 ? n : 110;
    }

    function syncSticky() {
      var rect = buyBox.getBoundingClientRect();
      var topClear = headerOffset() + 8;
      // Hide sticky only while the primary ATC row is fully usable below the sticky header
      var ctaVisible = rect.bottom > topClear + 40 && rect.top < window.innerHeight - 24;
      bar.hidden = ctaVisible;
    }

    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (root._oxAddToCart) root._oxAddToCart();
      });
    }
  }

  function initFaq(root) {
    var faq = root.querySelector('[data-oxiram-faq]');
    if (!faq) return;

    function setIcon(item, open) {
      var icon = item.querySelector('.ox-lux-accord__icon, .ox-faq__chev');
      if (icon) icon.textContent = open ? '−' : '+';
    }

    faq.querySelectorAll('[data-oxiram-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-oxiram-faq-item]');
        var panel = item ? item.querySelector('[data-oxiram-faq-panel]') : null;
        if (!item || !panel) return;

        var isOpen = item.classList.contains('is-open');
        faq.querySelectorAll('[data-oxiram-faq-item]').forEach(function (other) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('[data-oxiram-faq-trigger]');
          var otherPanel = other.querySelector('[data-oxiram-faq-panel]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
          setIcon(other, false);
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
          setIcon(item, true);
        }
      });
    });
  }

  function initWriteReview(root) {
    var section = root.querySelector('[data-oxiram-reviews]');
    if (!section) return;
    var buttons = section.querySelectorAll('[data-oxiram-write-review]');
    var modal = section.querySelector('[data-oxiram-rev-modal]');
    var form = section.querySelector('[data-oxiram-rev-form]');
    var msg = section.querySelector('[data-oxiram-rev-msg]');
    var submitBtn = section.querySelector('[data-oxiram-rev-submit]');
    var ratingInput = section.querySelector('[data-oxiram-rev-rating]');
    var stars = section.querySelectorAll('[data-oxiram-rev-stars] [data-rating]');
    if (!buttons.length || !modal || !form) return;

    var shopDomain = section.getAttribute('data-shop-domain') || '';
    var productId = section.getAttribute('data-product-id') || '';

    function setRating(value) {
      var n = Math.max(1, Math.min(5, Number(value) || 5));
      if (ratingInput) ratingInput.value = String(n);
      Array.prototype.forEach.call(stars, function (star) {
        var r = Number(star.getAttribute('data-rating'));
        star.classList.toggle('is-active', r <= n);
      });
    }
    setRating(5);

    Array.prototype.forEach.call(stars, function (star) {
      star.addEventListener('click', function () {
        setRating(star.getAttribute('data-rating'));
      });
    });

    function openModal() {
      modal.hidden = false;
      document.body.classList.add('ox-rev-modal-open');
      var first = form.querySelector('input[name="name"]');
      if (first) window.setTimeout(function () { first.focus(); }, 50);
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('ox-rev-modal-open');
      if (msg) {
        msg.hidden = true;
        msg.textContent = '';
        msg.classList.remove('is-error');
      }
    }

    function tryNativeJudgeMe() {
      var widget = document.getElementById('judgeme_product_reviews');
      var native =
        (widget && widget.querySelector('.jdgm-write-rev-link, .jdgm-write-review-modal, [data-jdgm-write-review]')) ||
        document.querySelector('.jdgm-write-rev-link');
      if (native) {
        native.click();
        return true;
      }
      if (window.jdgm && window.jdgm.custom && typeof window.jdgm.custom.openReviewForm === 'function') {
        try {
          window.jdgm.custom.openReviewForm();
          return true;
        } catch (err) {}
      }
      return false;
    }

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (tryNativeJudgeMe()) return;
        openModal();
      });
    });

    section.querySelectorAll('[data-oxiram-rev-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!shopDomain || !productId) {
        if (msg) {
          msg.hidden = false;
          msg.classList.add('is-error');
          msg.textContent = 'Unable to submit review right now. Please try again later.';
        }
        return;
      }

      var data = new FormData(form);
      var payload = {
        shop_domain: shopDomain,
        platform: 'shopify',
        id: Number(productId),
        name: String(data.get('name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        rating: Number(data.get('rating') || 5),
        title: String(data.get('title') || '').trim(),
        body: String(data.get('body') || '').trim()
      };

      if (submitBtn) submitBtn.disabled = true;
      if (msg) {
        msg.hidden = true;
        msg.classList.remove('is-error');
      }

      fetch('https://judge.me/api/v1/reviews', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (json) {
            return { ok: res.ok, status: res.status, json: json };
          });
        })
        .then(function (result) {
          if (submitBtn) submitBtn.disabled = false;
          if (result.ok || result.status === 200 || result.status === 201) {
            form.reset();
            setRating(5);
            if (msg) {
              msg.hidden = false;
              msg.classList.remove('is-error');
              msg.textContent = 'Thank you — your review was submitted and will appear after moderation.';
            }
            window.setTimeout(closeModal, 1600);
            return;
          }
          var errText =
            (result.json && (result.json.error || result.json.message)) ||
            'Could not submit review. Please check Judge.me settings and try again.';
          if (msg) {
            msg.hidden = false;
            msg.classList.add('is-error');
            msg.textContent = String(errText);
          }
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          if (msg) {
            msg.hidden = false;
            msg.classList.add('is-error');
            msg.textContent = 'Network error. Please try again.';
          }
        });
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.section-head, .jm-header, .prod-card, .jm-widget-panel');
    if (!items.length || !('IntersectionObserver' in window)) return;
    Array.prototype.forEach.call(items, function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    Array.prototype.forEach.call(items, function (el) {
      obs.observe(el);
    });
  }

  function boot(root) {
    if (!root || root.getAttribute('data-oxiram-pdp-ready')) return;
    root.setAttribute('data-oxiram-pdp-ready', '1');
    initGallery(root);
    initBuyBox(root);
    initStickyCart(root);
    initFaq(root);
    initWriteReview(root);
    initReveal(root);
  }

  function bootAll() {
    document.querySelectorAll('[data-oxiram-product]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-oxiram-product]') || e.target;
    if (root && root.hasAttribute && root.hasAttribute('data-oxiram-product')) {
      root.removeAttribute('data-oxiram-pdp-ready');
      boot(root);
    }
  });
})();
